<template>
  <div class="logo-header">
    <img
      width="230"
      height="45"
      :src="getImgPath(imgName)"
      alt="superthread logo"
      class="small-logo"
    />
  </div>
</template>

<script>
export default {
  name: 'SmallLogo',
  computed: {
    theme() {
      return this.$store.getters.getTheme;
    },
    imgName() {
      return this.theme === 'dark' ? 'small-logo-light' : 'small-logo-dark';
    },
  },
  methods: {
    getImgPath(image) {
      const logo = require.context('@/assets/images', false);
      return logo(`./${image}.svg`);
    },
  },
};
</script>
